// Module
var code = "<div id=\"V-223DA586-7BAB-481C-8963-5A1C7B82FE0D\"> <div data-b-component=\"grid\" data-b-comp-columnDefinition=\"auto 1fr\"> <h6 data-b-attach-column=\"1\">پیش فرض : </h6> <div data-b-attach-column=\"2\" data-b-component=\"content\" data-b-comp-content=\"{Binding combo}\"></div> </div> </div> ";
// Exports
export default code;